export default "__VITE_ASSET__B_2GaYmq__"